import React, { useEffect, useState } from 'react'
import Layout from './Components/Layout/Layout'
import "./App.css"
import GetACallBack from './Components/UI/GetACallBack'
import PopupForm from './Components/UI/PopupForm'
import FabButton from './Components/UI/FabButton'

const App = () => {

  const [show, setShow] = useState(false)
  const [open, setOpen] = useState(false);
  useEffect(()=>{
    setTimeout(()=>{
      // setOpen(true)
    },15000)
   
  },[])
  
  return (
    <div>
    {show && <GetACallBack setShow={setShow}/> }
    {open && <PopupForm setOpen={setOpen} /> }
      <Layout setShow={setShow} setOpen={setOpen}  />
      <FabButton />
    </div>
  )
}

export default App
